/**
 * Hook to preserve the original basket ID for users during workshop checkout
 * When a logged-in user registers for a workshop, a new basket is created and becomes
 * the "active" basket on the backend. This hook stores the original basket ID in localStorage
 * so it can be restored after the workshop payment is complete.
 */

const ORIGINAL_BASKET_STORAGE_KEY = 'originalBasketId';

const getOriginalBasketIdFromStorage = () => {
  if (typeof window === 'undefined') {
    return;
  }

  return localStorage.getItem(ORIGINAL_BASKET_STORAGE_KEY);
};

const setOriginalBasketIdToStorage = (basketId: string) => {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.setItem(ORIGINAL_BASKET_STORAGE_KEY, basketId);
};

const deleteOriginalBasketIdFromStorage = () => {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.removeItem(ORIGINAL_BASKET_STORAGE_KEY);
};

export const useOriginalBasket = () => {
  return {
    originalBasketId: getOriginalBasketIdFromStorage(),
    setOriginalBasketId: setOriginalBasketIdToStorage,
    deleteOriginalBasketId: deleteOriginalBasketIdFromStorage,
    getOriginalBasketId: getOriginalBasketIdFromStorage,
  };
};
